module.exports = __webpack_public_path__ + "img/left1.2df10a58.png";